module.exports = __webpack_public_path__ + "img/guide.c479eb6d.svg";